<template>
  <div class="theme-container" v-if="root !== undefined">
    <span class="theme-header">{{ root.theme.title }}</span>
    <theme-display v-bind:themes="themes" v-if="root.children.length > 0" v-bind:nodes="root.children"
                   v-bind:entity-themes="entityThemes"></theme-display>
  </div>
</template>
<script lang="ts">

import {Options, Vue} from "vue-class-component";
import {ThemeTreeNode} from '@/entities/ThemeTree';
import ThemeDisplay from '@/components/ThemeDisplay.vue';
import {PropType} from 'vue';
import {Theme} from '@/entities/Theme';

@Options({
  components: {ThemeDisplay},
  props: {
    root: {
      default: undefined,
      required: true,
      type: ThemeTreeNode
    },
    themes: {
      default: [],
      required: true,
      type: Array as PropType<Array<Theme>>
    },
    entityThemes: {
      required: true,
      type: Array as PropType<Array<String>>
    }
  }
})
export default class ThemeRoot extends Vue {

  constructor(props) {
    super(props);
  }

}
</script>

<style lang="scss">

.theme-container{
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: wrap;


  .theme-header {
    border-bottom: 2px solid var(--primary-color);
    text-align: left;
    font-size: 1.2rem;
    font-weight: bold;
    margin-top: 16px;
    margin-bottom: 6px;
  }

}

</style>
